import { Component, inject, Input } from '@angular/core';
import { CardModule } from 'primeng/card';
import { MachinePlacementItemDto } from 'src/app/shared/dtos/machine.dto';
import { TruncateLocation } from 'src/app/shared/enums/truncate-location.enum';
import { TruncatePipe } from 'src/app/shared/pipes/truncate.pipe';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';
import { DownloadMediaService } from 'src/app/shared/services/download-media.service';
import { DialogService } from 'primeng/dynamicdialog';
import { PlacementMediaModalComponent } from 'src/app/core/components/modals/placement-media-modal/placement-media-modal.component';

@Component({
  selector: 'app-placement-content-card',
  imports: [
    CardModule,
    TruncatePipe,
  ],
  templateUrl: './placement-content-card.html',
  styleUrl: './placement-content-card.scss',
})
export class PlacementContentCard {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly downloadMediaService = inject(DownloadMediaService);
  private readonly dialogService = inject(DialogService);

  @Input({ required: true }) item!: MachinePlacementItemDto;

  TruncateLocation: typeof TruncateLocation;

  constructor() {
    this.TruncateLocation = TruncateLocation;
  }

  handleCardClick(item: MachinePlacementItemDto): void {
    if (item.item.file_type !== 'application/pdf') {
      this.dialogService.open(PlacementMediaModalComponent, {
        focusOnShow: false,
        closable: true,
        modal: true,
        dismissableMask: true,
        width: 'auto',
        height: 'auto',
        draggable: false,
        styleClass: 'transparent-dialog',
        inputValues: {
          item: item,
        },
      });
    } else if (item.item.file_type === 'application/pdf') {
      window.open(item.item.public_asset_url, '_blank');
    }
    
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      ...this.analyticsService.analyticsPageData,
      screenName: 'asset',
      itemName: item.title,
      itemId: item.item.asset_id,
    });
  }

  async handleDownload(item: MachinePlacementItemDto, event: Event): Promise<void> {
    event.stopPropagation();
    const url = item.item.public_asset_url;
    const title = item.title;

    this.downloadMediaService.getMedia(url).subscribe({
      next: (blob) => {
        const link = document.createElement('a');
        const linkUrl = window.URL.createObjectURL(blob);
        link.href = linkUrl;
        link.download = title;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(linkUrl);

        this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
          ...this.analyticsService.analyticsPageData,
          screenName: 'downloaded',
          itemName: title,
          itemId: item.item.asset_id
        });
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
}
